import React from "react";
import {Box} from "@unibuddy/patron";
import styled from "styled-components";
import {processHtmlContent} from "../../../../widgets/modules/Content/utils";

type BlogPostTextProps = {
    body: string;
};

const PostBody = styled.div`
    & * {
        margin: 0;
    }

    /* Display all images with max available width */
    & img {
        max-width: 100%;
        display: block;
        margin: 0 auto;
    }
`;

export const BlogPostText = ({body}: BlogPostTextProps) => {
    return (
        <Box padding={"small"} color={"var(--light-body-colour)"}>
            <PostBody
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{__html: processHtmlContent(body)}}
            />
        </Box>
    );
};
